import React from "react";

import { Input, Button } from "antd";
import { Col, Row, } from "antd";
import history from "../../../routes/history";
import moment from 'moment';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import editicon from "../../../assets/img/editicon.png";
import deleteicon from "../../../assets/img/deleteicon.png";
import './GigListing.css';




export default function GigListing({item}) {
  
    return (


            <Col className="mr-bottom"
            xs={24} sm={24} md={12} lg={12}
            >
            
            <Col
            xs={22} sm={22} md={12} lg={12}
            className="giglisting-container"
            // className="giglisting-container"
            // style={{background: 'green'}}
            >
                <div style={{padding:'3%'}}>
                <Row>
                    <div className="giglisting-exp" >Expires in {moment(item.ExpiryDate).fromNow()}</div>
                    {/* <div className={'iconContainer'}>
                                    <EditOutlined className={'iconStyle'} onClick={() => { history.push('edit-bid')}} />
                                    <DeleteOutlined className={'iconStyle'} onClick={() => { }} />
                                </div> */}
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent:'space-evenly',alignItems: 'center', width:'30%' }}>
                  <div  >
                    <img src={editicon} alt="editicon" style={{width: '20px', height: '20px', marginTop: '2%'}} 
                        onClick={()=>{
                          item?.JobOrderTypeName==="Permanent" ?
                            history.push({
                            pathname:'/per-gig',
                            state:{
                                Title: item.Title,
                                FacilityName: item.FacilityName,
                                Skills: item.Skills,
                                Location: item.Location.Location,
                                Experience : item.ExperienceLevelName,
                                
                            }
                        })
                        :
                        history.push({
                            pathname:'/contract-gig',
                            state:{
                                Title: item.Title,
                                FacilityName: item.FacilityName,
                                Skills: item.Skills,
                                Location: item.Location.Location,
                                Experience : item.ExperienceLevelName,
                                GigDuration :'7 months'
                            }
                        })
                    }
                    }
                    />
                  </div>
                  <div >
                    <img src={deleteicon} alt="deleteicon" style={{width: '20px', height: '20px'}}/>
                  </div>
                  </div>

                    {/* <div ><EditOutlined  onClick={() => { history.push('edit-bid')}} /></div>
                    <div ><DeleteOutlined  onClick={() => { }} /></div>          */}


                </Row>
                <div className="giglisting-head">{item.Title}</div>
                <div className="giglisting-txt">
                <div >Facility: {item.FacilityName}</div>
                <div >Location :{item.Location.Location}</div>
                <div >High bid : $ {item.BudgetMin}/{item.BudgetType}</div>
</div>
                {/* <Row>
                    <div> 0 Matches</div>
                    <div>0 Bids</div>
                </Row> */}

                <Row

                // style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}
                >

                        <Col span={11}
                        // style={{marginRight: '4%'}}
                        style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '4%'}}
                        >

                    <Button className='giglisting-btn1'>0 Matches</Button>

                    </Col>
                    <Col span={12}
                    // style={{marginLeft: '4%'}}
                    >
                    <Button className='giglisting-btn2'>0 Bids</Button>

                    </Col>
                    </Row>
                    </div>


                    <div className="giglisting-profileDivider"></div>
                <div className={'giglisting-modified'}>
                Modified on {moment(item.Modified).format('dddd, MMMM DD, YYYY hh:mm a')}
                    {/* {moment(props.item.Modified).format('ddd, MMMM DD, yyyy hh:mm a')} */}
                </div>
            </Col>
  
         </Col>       
    )   
}
